"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostcodePolygonAttributes$ = exports.PostcodePolygonAttributes$outboundSchema = exports.PostcodePolygonAttributes$inboundSchema = exports.PostcodePolygonAttributesEpsg4326Polygon$ = exports.PostcodePolygonAttributesEpsg4326Polygon$outboundSchema = exports.PostcodePolygonAttributesEpsg4326Polygon$inboundSchema = exports.Epsg27700Polygon$ = exports.Epsg27700Polygon$outboundSchema = exports.Epsg27700Polygon$inboundSchema = void 0;
exports.epsg27700PolygonToJSON = epsg27700PolygonToJSON;
exports.epsg27700PolygonFromJSON = epsg27700PolygonFromJSON;
exports.postcodePolygonAttributesEpsg4326PolygonToJSON = postcodePolygonAttributesEpsg4326PolygonToJSON;
exports.postcodePolygonAttributesEpsg4326PolygonFromJSON = postcodePolygonAttributesEpsg4326PolygonFromJSON;
exports.postcodePolygonAttributesToJSON = postcodePolygonAttributesToJSON;
exports.postcodePolygonAttributesFromJSON = postcodePolygonAttributesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const multipolygonmodel_js_1 = require("./multipolygonmodel.js");
const osgbmultipolygonmodel_js_1 = require("./osgbmultipolygonmodel.js");
const osgbpolygonmodel_js_1 = require("./osgbpolygonmodel.js");
const polygonmodel_js_1 = require("./polygonmodel.js");
/** @internal */
exports.Epsg27700Polygon$inboundSchema = z.union([
    osgbpolygonmodel_js_1.OSGBPolygonModel$inboundSchema,
    osgbmultipolygonmodel_js_1.OSGBMultiPolygonModel$inboundSchema,
]);
/** @internal */
exports.Epsg27700Polygon$outboundSchema = z.union([
    osgbpolygonmodel_js_1.OSGBPolygonModel$outboundSchema,
    osgbmultipolygonmodel_js_1.OSGBMultiPolygonModel$outboundSchema,
]);
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Epsg27700Polygon$;
(function (Epsg27700Polygon$) {
    /** @deprecated use `Epsg27700Polygon$inboundSchema` instead. */
    Epsg27700Polygon$.inboundSchema = exports.Epsg27700Polygon$inboundSchema;
    /** @deprecated use `Epsg27700Polygon$outboundSchema` instead. */
    Epsg27700Polygon$.outboundSchema = exports.Epsg27700Polygon$outboundSchema;
})(Epsg27700Polygon$ || (exports.Epsg27700Polygon$ = Epsg27700Polygon$ = {}));
function epsg27700PolygonToJSON(epsg27700Polygon) {
    return JSON.stringify(exports.Epsg27700Polygon$outboundSchema.parse(epsg27700Polygon));
}
function epsg27700PolygonFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Epsg27700Polygon$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Epsg27700Polygon' from JSON`);
}
/** @internal */
exports.PostcodePolygonAttributesEpsg4326Polygon$inboundSchema = z.union([polygonmodel_js_1.PolygonModel$inboundSchema, multipolygonmodel_js_1.MultiPolygonModel$inboundSchema]);
/** @internal */
exports.PostcodePolygonAttributesEpsg4326Polygon$outboundSchema = z.union([polygonmodel_js_1.PolygonModel$outboundSchema, multipolygonmodel_js_1.MultiPolygonModel$outboundSchema]);
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PostcodePolygonAttributesEpsg4326Polygon$;
(function (PostcodePolygonAttributesEpsg4326Polygon$) {
    /** @deprecated use `PostcodePolygonAttributesEpsg4326Polygon$inboundSchema` instead. */
    PostcodePolygonAttributesEpsg4326Polygon$.inboundSchema = exports.PostcodePolygonAttributesEpsg4326Polygon$inboundSchema;
    /** @deprecated use `PostcodePolygonAttributesEpsg4326Polygon$outboundSchema` instead. */
    PostcodePolygonAttributesEpsg4326Polygon$.outboundSchema = exports.PostcodePolygonAttributesEpsg4326Polygon$outboundSchema;
})(PostcodePolygonAttributesEpsg4326Polygon$ || (exports.PostcodePolygonAttributesEpsg4326Polygon$ = PostcodePolygonAttributesEpsg4326Polygon$ = {}));
function postcodePolygonAttributesEpsg4326PolygonToJSON(postcodePolygonAttributesEpsg4326Polygon) {
    return JSON.stringify(exports.PostcodePolygonAttributesEpsg4326Polygon$outboundSchema.parse(postcodePolygonAttributesEpsg4326Polygon));
}
function postcodePolygonAttributesEpsg4326PolygonFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PostcodePolygonAttributesEpsg4326Polygon$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PostcodePolygonAttributesEpsg4326Polygon' from JSON`);
}
/** @internal */
exports.PostcodePolygonAttributes$inboundSchema = z.object({
    epsg_27700_polygon: z.nullable(z.union([
        osgbpolygonmodel_js_1.OSGBPolygonModel$inboundSchema,
        osgbmultipolygonmodel_js_1.OSGBMultiPolygonModel$inboundSchema,
    ])),
    epsg_4326_polygon: z.nullable(z.union([polygonmodel_js_1.PolygonModel$inboundSchema, multipolygonmodel_js_1.MultiPolygonModel$inboundSchema])),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "epsg_27700_polygon": "epsg27700Polygon",
        "epsg_4326_polygon": "epsg4326Polygon",
    });
});
/** @internal */
exports.PostcodePolygonAttributes$outboundSchema = z.object({
    epsg27700Polygon: z.nullable(z.union([
        osgbpolygonmodel_js_1.OSGBPolygonModel$outboundSchema,
        osgbmultipolygonmodel_js_1.OSGBMultiPolygonModel$outboundSchema,
    ])),
    epsg4326Polygon: z.nullable(z.union([polygonmodel_js_1.PolygonModel$outboundSchema, multipolygonmodel_js_1.MultiPolygonModel$outboundSchema])),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        epsg27700Polygon: "epsg_27700_polygon",
        epsg4326Polygon: "epsg_4326_polygon",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PostcodePolygonAttributes$;
(function (PostcodePolygonAttributes$) {
    /** @deprecated use `PostcodePolygonAttributes$inboundSchema` instead. */
    PostcodePolygonAttributes$.inboundSchema = exports.PostcodePolygonAttributes$inboundSchema;
    /** @deprecated use `PostcodePolygonAttributes$outboundSchema` instead. */
    PostcodePolygonAttributes$.outboundSchema = exports.PostcodePolygonAttributes$outboundSchema;
})(PostcodePolygonAttributes$ || (exports.PostcodePolygonAttributes$ = PostcodePolygonAttributes$ = {}));
function postcodePolygonAttributesToJSON(postcodePolygonAttributes) {
    return JSON.stringify(exports.PostcodePolygonAttributes$outboundSchema.parse(postcodePolygonAttributes));
}
function postcodePolygonAttributesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PostcodePolygonAttributes$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PostcodePolygonAttributes' from JSON`);
}
//# sourceMappingURL=postcodepolygonattributes.js.map